export class blackScreenCover {
  private parent: PIXI.Container;
  private frame: PIXI.Graphics;
  private anchor:Array<number>=[0,0];

  constructor(parentBGFixed: PIXI.Container) {
    this.parent = new PIXI.Container();
    parentBGFixed.addChild(this.parent);
    this.frame = new PIXI.Graphics();
    this.frame.beginFill(0x000000);
    this.frame.drawRect(0, 0, 10, 10);
    this.frame.endFill();
    this.frame.alpha = 0.5;
    this.parent.addChild(this.frame);
    this.frame.width = 1375;
    this.frame.height = 750;
    this.onResize();
    this.close();
  }

  public setAlpha = (newAlpha: number): void => {
    this.frame.alpha = newAlpha;
  };

  public getIsVisibile = (): boolean => {
    return this.frame.alpha > 0;
  };

  public setVisible = (bool: boolean): void => {
    if (bool) {
      this.open();
    } else if (bool == false) {
      this.close();
    }
  };
  private close = (): void => {
    this.parent.alpha = 0;
    this.parent.interactive=false;
  };

  private open = (): void => {
    this.parent.alpha = 1;
    this.parent.interactive=true;
  };

  public onResize = (): void => {
 
      let canvas = document.getElementsByTagName("canvas")[0];

      this.frame.width = canvas.width;
      this.frame.height = canvas.height;
      this.setAnchor(this.anchor[0],this.anchor[1]);
  };
  public getParent=():PIXI.Container=>
  {
    return this.parent
  }
  public setAnchor=(ancX:number,ancY:number):void=>
  {
    this.anchor=[ancX,ancY];
    this.frame.x=-ancX*this.frame.width;
    this.frame.y=-ancY*this.frame.height;
  }
}
